import React from 'react';
import { PageModeEnum } from '../../common/contracts';
import { Typography } from '@material-ui/core';
import { Container } from '../styles';
import { PharmaceuticalForm } from '../components';

export default function MyDataPage(): JSX.Element {
  return (
    <Container>
      <Typography variant="h4" style={{ width: '100%', color: '#000000' }}>
        Meus dados
      </Typography>
      <PharmaceuticalForm mode={PageModeEnum.UPDATE}/>
    </Container>
  );
}
